<template>
  <main
    v-if="about"
    class="about">
    <ul
      class="about__links">
      <li>
        <p v-html="'Jonathan West'.toUpperCase()"></p>
      </li>
      <li>
        <a
          v-if="about.address.link && about.address.link !== ''"
          :href="about.address.link"
          target="_blank"
          rel="noopener noreferrer">
          A. {{ about.address.text }}
        </a>
        <p v-else>
          A. {{ about.address.text }}
        </p>
      </li>
      <li>
        <a
          :href="`tel:${about.phone.link}`"
          target="_blank"
          rel="noopener noreferrer">
          P. {{ about.phone.text }}
        </a>
      </li>
      <li>
        <a
          :href="`mailto:${about.email.link}`"
          target="_blank"
          rel="noopener noreferrer">
          E. {{ about.email.text }}
        </a>
      </li>
      <li>
        <a
          :href="`${about.instagram.link}`"
          target="_blank"
          rel="noopener noreferrer">
          I. {{ about.instagram.text }}
        </a>
      </li>
    </ul>
    <div
      class="wysiwyg"
      v-html="about.overview"></div>
  </main>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      about: null
    }
  },
  async created() {
    this.about = await this.getAbout()

    this.$Progress.finish()
  },
  methods: {
    getAbout() {
      return new Promise((resolve) => {
        this.$http.get(`${process.env.VUE_APP_API_ADDRESS}/about`)
          .then(response => response.json())
          .then(result => resolve(result))
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$Progress.start()
    })
  }
}
</script>

<style lang="scss" scoped>
.about {
  @include page($margin: false);
  font-family: $maison;

  &__links {
    width:50%;
    margin:0 0 $site-padding-lrg 15%;
    position:relative;
    z-index:2;

    a {
      &:hover {
        color:$hover-color;
      }
    }
  }

  .wysiwyg {
    max-width: 1400px;
    // margin:0 0 $site-padding-lrg 25%;
  }

  @include mobile {
    &__links {
      width:100%;
      margin: 0 0 $site-padding-lrg 0;
    }
    .wysiwyg {
      margin:0px;
    }
  }

}
</style>
